// extracted by mini-css-extract-plugin
export default {"projectFab":"ProjectFab_projectFab__MjfbT","projectFabButton":"ProjectFab_projectFabButton__fkXti","projectFabButtonIcon":"ProjectFab_projectFabButtonIcon__FTx3F"};